module.exports = __webpack_public_path__ + "static/media/aboutimg1.d09e1017.jpg";